let WORDS = [
    "chaco",
    "pucho",
    "cheto",
    "peron",
    "potro",
    "mates",
    "coscu",
    "bardo",
    "guita",
    "piola",
    "zapan",
    "pachu",
    "milei",
    "bondi",
    "yerba",
    "cheto",
    "menem",
    "asado",
    "macri",
    "truco",
    "tango",
    "okupa",
    "chano",
    "cheta",
    "messi",
    "jujuy",
    "river",
    "chimi",
    "diego",
    "cazzu",
    "tinto",
    "salta",
    "tevez",
    "locro",
    "quino",
]

export default WORDS